/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Export_ButtonInputs */

const en_shortcut_keys_export_button = /** @type {(inputs: Shortcut_Keys_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const fr_shortcut_keys_export_button = /** @type {(inputs: Shortcut_Keys_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter`)
};

const de_shortcut_keys_export_button = /** @type {(inputs: Shortcut_Keys_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const it_shortcut_keys_export_button = /** @type {(inputs: Shortcut_Keys_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportare`)
};

const ru_shortcut_keys_export_button = /** @type {(inputs: Shortcut_Keys_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт`)
};

const es_shortcut_keys_export_button = /** @type {(inputs: Shortcut_Keys_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

const zh_cn2_shortcut_keys_export_button = /** @type {(inputs: Shortcut_Keys_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口`)
};

const ja_shortcut_keys_export_button = /** @type {(inputs: Shortcut_Keys_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸出`)
};

const hi_shortcut_keys_export_button = /** @type {(inputs: Shortcut_Keys_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात`)
};

const pt_pt2_shortcut_keys_export_button = /** @type {(inputs: Shortcut_Keys_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

/**
* | output |
* | --- |
* | "Export" |
*
* @param {Shortcut_Keys_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_export_button = /** @type {((inputs?: Shortcut_Keys_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_export_button(inputs)
	if (locale === "de") return de_shortcut_keys_export_button(inputs)
	if (locale === "it") return it_shortcut_keys_export_button(inputs)
	if (locale === "ru") return ru_shortcut_keys_export_button(inputs)
	if (locale === "es") return es_shortcut_keys_export_button(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_export_button(inputs)
	if (locale === "ja") return ja_shortcut_keys_export_button(inputs)
	if (locale === "hi") return hi_shortcut_keys_export_button(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_export_button(inputs)
	return en_shortcut_keys_export_button(inputs)
});